
































































import {namespace} from 'vuex-class';
import {Component, Vue, Watch} from 'vue-property-decorator';

import BtnDefault from '@/components/UI/BtnDefault.vue';
import DialogFooter from '@/components/UI/DialogFooter.vue';
import TooltipWithClose from '@/components/UI/TooltipWithClose.vue';
import Standman from '@/components/beta/Workspace/Company/Standman.vue';
import Company from '@/components/beta/Workspace/Company/Company.vue';

import IRadio from '@/components/icons/IRadio.vue'

const dialog = namespace('dialog')
const forms = namespace('forms')
const profile = namespace('profile')

@Component({
  components: {
    BtnDefault,
    DialogFooter,
    TooltipWithClose,
    Standman,
    Company,
    IRadio,
  },
  name: "CreateCompanyForm"
})
export default class CreateCompanyForm extends Vue {
  @dialog.Getter('fullDialogShow') protected fullDialogShow: any
  @dialog.Mutation('SetFullDialogShow') protected SetFullDialogShow: any
  @forms.Getter('options') protected options:any

  @profile.Action('sendInvite') protected sendInvite: any
  @profile.Action('addCompany') protected addCompany: any
  @profile.Getter('userCompanies') protected userCompanies: any
  
  role:string = ''
  step:number = 1
  save:boolean = false
  loading:boolean = false

  @Watch('fullDialogShow')
  reset() {
    if(!this.fullDialogShow) {
      this.role = ''
      this.step = 1
    }
  }

  changeRole(role:any) {
    this.role = role
  }

  saveCompany() {
    this.loading = true
    this.save = true
  }

  async addNewCompany(params:any) {
    let data = await this.addCompany(params).then(() => {
      this.loading = false
      this.save = false
    })
    this.$router.push({name:"Corporate",params:{code:this.userCompanies[this.userCompanies.length - 1].company.code}}).catch(() => {})
  }

}
